const initProductModalResponseHandler = (actualUrl) => {
    const contactParameter = actualUrl.searchParams.get("buy");
    const successModal = document.querySelector(".product-modal.success");
    const errorModal = document.querySelector(".product-modal.error");
    const closeErrorModal = document.querySelector(".product-modal.error .close-icon");
    const closeSuccessModal = document.querySelector(".product-modal.success .close-icon");
    if (contactParameter === "1") {
        successModal.classList.remove('not-visible');
        successModal.classList.add('is-visible');
    }
    else if (contactParameter === "0") {
        errorModal.classList.remove('not-visible');
        errorModal.classList.remove('is-visible');
    }
    closeErrorModal.addEventListener('click', () => {
        document.querySelector(".product-modal.error").classList.remove('is-visible');
        document.querySelector(".product-modal.error").classList.add('not-visible');
    });
    closeSuccessModal.addEventListener('click', () => {
        document.querySelector(".product-modal.success").classList.remove('is-visible');
        document.querySelector(".product-modal.success").classList.add('not-visible');
    });
};
